<div class="wrap-all">
  <div class="wrap">
    <div class="number">
      <span class="text">{{ row }}.</span>
    </div>
    <div class="fields">
      <div class="fileds-inner-warp">
        <div class="field">
          <label class="title required" for="amountInILS">
            {{ "questionBoard.edit.expense.amountInILS" | translate }}
          </label>

          <div class="input-wrapper">
            <span class="currency">₪</span>
            <input
              id="amountInILS"
              type="number"
              step="0.01"
              min="0"
              [value]="expense.controls.amountInILS.value"
              (blur)="setAmountInILS($event)"
              [disabled]="!isUser"
              placeholder="{{
                'questionBoard.edit.expense.amountInILS' | translate
              }}"
            />
          </div>
        </div>
        <div class="field">
          <label class="title required" for="date">{{
            "questionBoard.edit.expense.date" | translate
          }}</label>
          <div
            class="input-wrapper"
            #trigger
            (click)="openPopupDate()"
            [ngClass]="{ pointer: isUser }"
          >
            <input
              class="date-input"
              [ngClass]="{ pointer: isUser }"
              placeholder="{{ 'questionBoard.display.chooseDate' | translate }}"
              value="{{
                expense.controls.date.value
                  | queDate: question?.definitions?.formatDate
              }}"
              readonly
            />
          </div>
          <ng-template
            cdkConnectedOverlay
            [cdkConnectedOverlayOrigin]="trigger"
            [cdkConnectedOverlayHasBackdrop]="true"
            (backdropClick)="selectedDateIsOpened = false"
            [cdkConnectedOverlayOpen]="selectedDateIsOpened"
            cdkConnectedOverlayBackdropClass="backdrop-selection"
            [cdkConnectedOverlayPositions]="positonAreaForSelectedDate"
          >
            <que-dual-calendar-range-picker
              *ngIf="question?.definitions?.formatDate != 'YYYY/MM'"
              [customDateFrom]="expense.controls.date.value"
              [maxSelectableDate]="today"
              (rangeChanged)="chooseDate($event)"
              [isSingalDate]="true"
            ></que-dual-calendar-range-picker>
          </ng-template>
        </div>
        <!-- <div > -->
        <!-- <label class="title required">{{ 'questionBoard.edit.expense.currencyType' | translate }}</label> -->
        <!-- <div class="input-wrapper input-currency" > -->
        <!-- <span class="currency">{{ selectedCurrency }}</span> -->
        <!-- <img src="/assets/images/arrow-down.svg" /> -->
        <!-- <ng-template cdkConnectedOverlay [cdkConnectedOverlayOrigin]="currencyTrigger"
                            [cdkConnectedOverlayHasBackdrop]="true"
                            cdkConnectedOverlayBackdropClass="backdrop-selection"
                            (backdropClick)="isSelectCurrencyOpen = false"
                            [cdkConnectedOverlayOpen]="isSelectCurrencyOpen"
                            [cdkConnectedOverlayPositions]="positonArea">
                            <div class="menuSteps">
                                <div *ngFor="let op of currencyList" class="op">
                                    /* (click)="isUser? updateSelectionCurrency(op): isSelectCurrencyOpen = false">
                                    <p translate>
                                        {{ op }}
                                    </p> */
                                </div>
                            </div>
                        </ng-template> -->
        <!-- </div> -->
        <!-- </div> -->
        <!-- <div class="field" *ngIf="selectedCurrency != '₪'">
                    <label class="title required" for="amount">{{'questionBoard.edit.expense.amount' |
                        translate}}</label>
                    <div class="input-wrapper">
                        <input id="amount" type="number" step="0.01" min="0" [value]="expense.controls.amount.value"
                            (blur)="setAmount($event)" [disabled]="!isUser"
                            placeholder="{{ 'questionBoard.edit.expense.amount' | translate }}" />
                    </div>
                </div> -->
        <!-- <div class="field" *ngIf="selectedCurrency != '₪'">
                    <label class="title required" for="exchangeRate">{{'questionBoard.edit.expense.exchangeRate' |
                        translate}}</label>
                    <div class="input-wrapper">
                        <input id="exchangeRate" type="number" step="0.01" min="0"
                            [value]="expense.controls.exchangeRate.value" (blur)="setExchangeRate($event)"
                            [disabled]="!isUser"
                            placeholder="{{ 'questionBoard.edit.expense.exchangeRate' | translate }}" />
                    </div>
                </div> -->
        <!-- <div class="field none"></div>
                <div class="field none"></div> -->
      </div>
      <div class="fileds-inner-warp">
        <div class="field">
          <label class="title required" for="amount">{{
            "questionBoard.edit.expense.expenseType" | translate
          }}</label>
          <div
            class="input-wrapper"
            #typeTrigger="cdkOverlayOrigin"
            cdkOverlayOrigin
            [ngClass]="{ pointer: isUser }"
            (click)="isUser && (isSelectTypeOpen = true)"
          >
            <p [class.placeholder]="!expense.controls.expenseType.value">
              {{
                expense.controls.expenseType.value?.name ||
                  ("questionBoard.edit.expense.choose" | translate)
              }}
            </p>
            <img src="/assets/images/arrow-down.svg" />
          </div>
          <ng-template
            cdkConnectedOverlay
            [cdkConnectedOverlayOrigin]="typeTrigger"
            [cdkConnectedOverlayHasBackdrop]="true"
            cdkConnectedOverlayBackdropClass="backdrop-selection"
            (backdropClick)="isSelectTypeOpen = false"
            [cdkConnectedOverlayOpen]="isSelectTypeOpen"
            [cdkConnectedOverlayPositions]="positonArea"
          >
            <div class="menuSteps">
              <ng-container
                *ngIf="
                  question?.optionsList?.answerOptionItem?.length;
                  else emptyList
                "
              >
                <div
                  *ngFor="let op of question?.optionsList?.answerOptionItem"
                  class="op"
                  (click)="
                    isUser
                      ? updateSelectionType(op)
                      : (isSelectTypeOpen = false)
                  "
                >
                  <p translate>
                    {{ op.name }}
                  </p>
                </div>
              </ng-container>
              <ng-template #emptyList>
                <div class="op empty-message">
                  <p translate>questionBoard.edit.expense.emptyList</p>
                </div>
              </ng-template>
            </div>
          </ng-template>
        </div>
        <div class="field flex-2">
          <label class="title" for="description">{{
            "questionBoard.edit.expense.description" | translate
          }}</label>
          <div class="input-wrapper">
            <input
              id="description"
              type="text"
              [formControl]="expense.controls.description"
              placeholder="{{
                'questionBoard.edit.expense.description' | translate
              }}"
            />
          </div>
        </div>
      </div>

      <div class="fileds-inner-warp">
        <div class="field">
          <label class="title required" for="documentNumber">{{
            "questionBoard.edit.expense.documentNumber" | translate
          }}</label>
          <div class="input-wrapper">
            <input
              id="documentNumber"
              type="text"
              [formControl]="expense.controls.documentNumber"
              placeholder="{{
                'questionBoard.edit.expense.documentNumber' | translate
              }}"
            />
          </div>
        </div>
      </div>
      <div class="fileds-inner-warp">
        <div class="field">
          <label class="title required">{{
            "questionBoard.edit.expense.attachmentFiles" | translate
          }}</label>
          <que-upload-file-local-display
            [formControl]="expense.controls.files"
            [isMulty]="true"
            [isUser]="isUser"
            [isIcon]="question?.definitions?.isIconUploadFile"
          ></que-upload-file-local-display>
        </div>
      </div>

      <div class="fileds-inner-warp">
        <div class="field field-inline">
          <label class="title">{{
            "questionBoard.edit.expense.clientCharge" | translate
          }}</label>
          <que-toggle
            [toggleState]="!!expense.controls.clientCharge.value"
            (toggleEvent)="
              canEditClientChargeFields() &&
                expense.controls.clientCharge.setValue($event)
            "
          >
          </que-toggle>
        </div>
        <div class="field" *ngIf="expense.controls.clientCharge.value">
          <label class="title">{{
            "questionBoard.edit.expense.fullcharge" | translate
          }}</label>
          <div class="input-wrapper toggle-wrapper">
            <button
              type="button"
              class="toggle-btn"
              [class.active]="expense.controls.fullcharge.value === 'full'"
              [disabled]="!canEditClientChargeFields()"
              (click)="
                canEditClientChargeFields() &&
                  expense.controls.fullcharge.setValue('full')
              "
            >
              {{ "questionBoard.edit.expense.chargeFull" | translate }}
            </button>
            <button
              type="button"
              class="toggle-btn"
              [class.active]="expense.controls.fullcharge.value === 'partial'"
              [disabled]="!canEditClientChargeFields()"
              (click)="
                canEditClientChargeFields() &&
                  expense.controls.fullcharge.setValue('partial')
              "
            >
              {{ "questionBoard.edit.expense.chargePartial" | translate }}
            </button>
          </div>
        </div>
        <div class="field" *ngIf="expense.controls.clientCharge.value">
          <label class="title" for="clientChargeAmount">{{
            "questionBoard.edit.expense.clientChargeAmount" | translate
          }}</label>
          <div class="input-wrapper">
            <span class="currency">₪</span>
            <input
              id="clientChargeAmount"
              type="number"
              step="0.01"
              min="0"
              [value]="expense.controls.clientChargeAmount.value"
              (blur)="setClientChargeAmount($event)"
              [readonly]="
                !canEditClientChargeFields() &&
                expense.controls.fullcharge.value === 'full'
              "
              placeholder="{{
                'questionBoard.edit.expense.clientChargeAmount' | translate
              }}"
            />
          </div>
        </div>
        <div class="field">
          <label class="title" for="approvedAmount">
            {{ "questionBoard.edit.expense.approvedAmount" | translate }}
          </label>

          <div class="input-wrapper">
            <span class="currency">₪</span>
            <input
              id="approvedAmount"
              type="number"
              step="0.01"
              min="0"
              [max]="expense.controls.amountInILS.value"
              [value]="expense.controls.approvedAmount.value"
              (blur)="setApprovedAmount($event)"
              [readonly]="!canEditClientChargeFields()"
            />
          </div>
        </div>
        <div class="field flex-2">
          <label class="title" for="commentAproval">
            {{ "questionBoard.edit.expense.commentAproval" | translate }}
          </label>

          <div class="input-wrapper">
            <input
              id="commentAproval"
              type="text"
              [formControl]="expense.controls.commentAproval"
              [readonly]="!canEditClientChargeFields()"
              placeholder="{{
                'questionBoard.edit.expense.commentAproval' | translate
              }}"
            />
          </div>
        </div>
      </div>
    </div>
    <div
      *ngIf="isUser && canDelete"
      class="delete-icon"
      (click)="deleteExpenseSun()"
    >
      <svg-icon
        class="icon"
        svgClass="icon-close"
        src="/assets/images/close.svg"
      ></svg-icon>
    </div>
  </div>
  <div class="error-message" *ngIf="expenseErrorMessage">
    {{ expenseErrorMessage }}
  </div>
</div>
